<template>
    <v-row justify="center">
        <v-dialog v-model="dialog" persistent max-width="600px" @keydown.esc.stop="close">
            <v-card>
                <v-card-title class="text-h5 bg-grey-lighten-2">
                    <span class="text-h5">Create Samples</span>
                </v-card-title>
                <v-card-text class="mt-5">
                    <v-form class="" v-model="isFormValid" ref="form">
                        <v-autocomplete
                            v-model="selectedContainer"
                            :items="filteredContainers"
                            item-title="name"
                            label="Select a Container type"
                            :rules="containerRules"
                            return-object
                            required
                            autofocus
                        ></v-autocomplete>
                        <v-autocomplete
                            v-model="selectedProtocols"
                            return-object
                            :items="filteredProtocols"
                            item-title="name"
                            :label="protocolLabel"
                            :rules="
                                disableExistingSamples ? protocolRulesMore : protocolRulesSingle
                            "
                            :multiple="!!disableExistingSamples"
                            required
                            searchable="false"
                        ></v-autocomplete>
                    </v-form>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" size="small" variant="text" @click="close">Cancel</v-btn>
                    <v-btn color="primary" :disabled="!isFormValid" @click="proceed" class="mr-3"
                        >Proceed</v-btn
                    >
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-row>
</template>
<script>
import { defineComponent } from "vue";

import _ from "lodash";
import { EventBus } from "@/lib/event-bus";
import { fetchContainerTypes } from "@/services/benchling/benchlingAPI";
import { samplesAPI } from "@/services/samples/samplesAPI";

export default defineComponent({
    name: "CreateSamplesDialog",

    data() {
        return {
            dialog: true,
            containerTypes: [],
            protocols: [],
            selectedContainer: undefined,
            selectedProtocols: [],
            // Form validation
            isFormValid: false,
            containerRules: [(v) => (v ? true : "Container selection is required")],
            protocolRulesMore: [(v) => (v.length > 0 ? true : "Select one or more protocols")],
            protocolRulesSingle: [(v) => (_.has(v, "registry_id") ? true : "Select a protocol")],
        };
    },

    computed: {
        // Controls if radio button 'Existing samples' should be enabled or not
        disableExistingSamples: function () {
            return (
                this.selectedContainer &&
                this.selectedContainer.rows === 1 &&
                this.selectedContainer.columns === 1
            );
        },
        protocolLabel: function () {
            return this.disableExistingSamples
                ? "Select one or more Protocols"
                : "Select a Protocol";
        },
        filteredContainers: function () {
            return this.containerTypes.filter((container) => container.num_wells === 1);
        },
        filteredProtocols: function () {
            return this.protocols;
        },
    },

    created() {
        this.init();
    },

    methods: {
        async init() {
            try {
                this.protocols = await samplesAPI.fetchSamplesProtocols();
                this.containerTypes = await fetchContainerTypes();
            } catch (err) {
                console.error(err);
                EventBus.$emit(
                    "message",
                    "Error loading dialog data. Please refresh your browser."
                );
            }
        },
        proceed() {
            // Emit selections to parent
            this.$emit("submit", {
                container: this.selectedContainer,
                protocols: _.isArray(this.selectedProtocols)
                    ? this.selectedProtocols
                    : [this.selectedProtocols],
                isSamplesBool: true,
            });
            this.dialog = false;
            this.$refs.form.reset();
        },
        close() {
            this.dialog = false;
            this.$refs.form.reset();
            window.history.back();
        },
    },

    watch: {
        disableExistingSamples: function (oldVal, newVal) {
            if (oldVal && !newVal) {
                this.selectedProtocols = [];
            } else {
                this.selectedProtocols = {};
            }
        },
    },
});
</script>

<style scoped></style>
